import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EmitirCinState } from './types';

export const INITIAL_STATE: EmitirCinState = {
	status: 0,
	data: null,
	dataError: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EmitirCinState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_CIN_REQUEST: {
				break;
			}
			case Types.EMITIR_CIN_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.EMITIR_CIN_FAILURE: {
				draft.status = action.payload.data.status;
				draft.dataError = action.payload.data.data;
				break;
			}
			case Types.EMITIR_CIN_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			default:
		}
		return draft;
	});
}
